module.exports = __webpack_public_path__ + "85974f79bec029eee10648a3c0bb6895.svg";